import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { finalize } from "rxjs/operators";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { EventAccessParams } from "src/app/models/EventAccessParams";
import { VisibleEvent } from "src/app/models/VisibleEvent";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";
import { ModalService } from "src/app/services/modal.service";
import { VisibleEventService } from "src/app/services/visible-event.service";

@Component({
  selector: "app-visible-event",
  templateUrl: "./visible-event.component.html",
  styleUrls: ["./visible-event.component.scss"],
  standalone: false,
})
export class VisibleEventComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  faSpinner = faSpinner;
  params: EventAccessParams;
  dataSource = new MatTableDataSource<VisibleEvent>([]);
  visibleEvents: VisibleEvent[] = [];
  isLoading: boolean;

  fam: string;
  role: string;
  events: VisibleEvent[];
  page: number = 1;
  pageSize: number = 10;

  constructor(
    private visibleEventService: VisibleEventService,
    private globalOverlayService: GlobalOverlayService,
    public modalService: ModalService,
  ) {
    this.getParams();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getParams() {
    this.globalOverlayService.show();
    this.isLoading = true;
    this.visibleEventService
      .getParams()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.globalOverlayService.close();
        }),
      )
      .subscribe((response) => {
        if (!response) return;
        this.params = response;
      });
  }

  getVisibleEvents() {
    this.globalOverlayService.show();
    this.isLoading = true;
    this.visibleEventService
      .getVisibleEvents(this.fam, this.role)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.globalOverlayService.close();
        }),
      )
      .subscribe((response) => {
        if (!response) return;
        this.visibleEvents = response;

        this.dataSource.data = this.params.events.map(
          (eventName) =>
            new VisibleEvent(
              eventName,
              this.fam,
              this.role,
              this.visibleEvents.some((x) => x.eventName == eventName),
            ),
        );
      });
  }

  deactivateEvent(eventName: string) {
    this.globalOverlayService.show();
    this.visibleEventService
      .deactivateEvent(this.fam, this.role, eventName)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe({
        next: (response) => {
          if (!response) return;
          this.getVisibleEvents();
        },
        error: () => this.getVisibleEvents(),
      });
  }

  activateEvent(eventName: string) {
    this.globalOverlayService.show();
    this.visibleEventService
      .activateEvent(this.fam, this.role, eventName)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe({
        next: (response) => {
          if (!response) return;
          this.getVisibleEvents();
        },
        error: () => this.getVisibleEvents(),
      });
  }

  onChange() {
    if (!this.fam || !this.role) return;

    this.getVisibleEvents();
  }

  activate(enabled: boolean, eventName: string) {
    if (!enabled) {
      this.deactivateEvent(eventName);
    } else {
      this.activateEvent(eventName);
    }
    enabled = !enabled;
  }
}
